// sessionStorage key used to bridge the ribbon-commands runtime and the
// taskpane runtime (per CLAUDE.md: the ONLY supported bridge between the two
// JavaScript runtimes). Both ends must read and write the same key, which is
// why it lives here rather than duplicated at each end.
export const TOAST_STORAGE_KEY = "aila_command_toast";
